<div class="flex flex-col items-center gap-5 py-4">

  <div class="flex items-center gap-3 w-full max-w-md">
    <span class="text-sm text-gray-500 whitespace-nowrap">Tienda:</span>
    <p-select
      [options]="shops"
      [(ngModel)]="selectedShopId"
      optionLabel="name"
      optionValue="id"
      placeholder="Seleccione una tienda"
      (onChange)="onShopChange($event)"
      class="flex-1">
    </p-select>
    <button
      *ngIf="messages.length > 0"
      pButton
      type="button"
      icon="pi pi-trash"
      class="p-button-text p-button-secondary p-button-sm"
      pTooltip="Limpiar chat"
      tooltipPosition="top"
      (click)="clearChat()">
    </button>
  </div>

  <div class="relative flex flex-col"
    style="width: 320px; height: 620px;
           background: #1a1a2e;
           border-radius: 44px;
           box-shadow: 0 0 0 2px #333, 0 0 0 5px #111, 0 30px 60px rgba(0,0,0,0.4);
           padding: 14px;">

    <div class="absolute top-0 left-1/2 -translate-x-1/2"
      style="width: 100px; height: 28px; background: #1a1a2e;
             border-radius: 0 0 20px 20px; z-index: 10;">
      <div class="absolute top-2 left-1/2 -translate-x-1/2 w-12 h-1.5 bg-black rounded-full"></div>
    </div>

    <div class="flex flex-col flex-1 overflow-hidden"
      style="background: #f5f5f5; border-radius: 32px; margin-top: 14px;">

      <div class="flex items-center gap-2 px-4 py-3"
        style="background: linear-gradient(135deg, #2563eb, #1d4ed8);">
        <div class="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
          <i class="pi pi-android text-white text-sm"></i>
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-white text-xs font-semibold truncate">Agente IA</p>
          <p class="text-blue-200 text-xs">En línea</p>
        </div>
        <i class="pi pi-ellipsis-v text-white text-sm opacity-60"></i>
      </div>

      <div *ngIf="!selectedShopId"
        class="flex-1 flex items-center justify-center bg-gray-50 p-4">
        <div class="text-center">
          <i class="pi pi-shop text-3xl text-gray-300 mb-2 block"></i>
          <p class="text-xs text-gray-400">Selecciona una tienda</p>
        </div>
      </div>

      <div *ngIf="selectedShopId"
        class="flex-1 overflow-y-auto p-3 space-y-2"
        style="background: #ece5dd url('data:image/svg+xml,') center;">

        <!-- Empty state -->
        <div *ngIf="messages.length === 0 && !isThinking"
          class="h-full flex items-center justify-center">
          <span class="text-xs text-gray-500 bg-white/80 px-3 py-1.5 rounded-full shadow-sm">
            Escribe algo para empezar
          </span>
        </div>

        <div *ngFor="let msg of messages" class="flex"
          [ngClass]="msg.role === 'user' ? 'justify-end' : 'justify-start'">
          <div class="max-w-[80%] px-3 py-2 rounded-2xl text-xs shadow-sm"
            [ngClass]="msg.role === 'user'
              ? 'bg-[#dcf8c6] text-gray-800 rounded-tr-sm'
              : 'bg-white text-gray-800 rounded-tl-sm'">
            <p class="leading-relaxed whitespace-pre-wrap">{{ msg.text }}</p>
            <div *ngIf="msg.role === 'ai' && msg.source"
              class="mt-1 flex items-center gap-1 opacity-40">
              <i class="pi pi-paperclip" style="font-size: 9px;"></i>
              <span style="font-size: 9px;">{{ msg.source }}</span>
            </div>
          </div>
        </div>

        <div *ngIf="isThinking" class="flex justify-start">
          <div class="bg-white rounded-2xl rounded-tl-sm px-3 py-2 shadow-sm flex gap-1 items-center">
            <span class="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce [animation-delay:0ms]"></span>
            <span class="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce [animation-delay:150ms]"></span>
            <span class="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce [animation-delay:300ms]"></span>
          </div>
        </div>
      </div>

      <div *ngIf="selectedShopId"
        class="flex items-center gap-2 px-3 py-2"
        style="background: #f0f0f0; border-top: 1px solid #ddd;">
        <input
          pInputText
          [(ngModel)]="input"
          placeholder="Escribe un mensaje..."
          class="flex-1 rounded-full text-xs"
          style="background: white; border-radius: 999px; padding: 6px 14px; font-size: 12px; border: none;"
          (keydown.enter)="send()"
          [disabled]="isThinking" />
        <button
          pButton
          type="button"
          icon="pi pi-send"
          class="p-button-rounded p-button-sm"
          style="width: 32px; height: 32px; background: #2563eb; border: none;"
          (click)="send()"
          [disabled]="isThinking || !input.trim()">
        </button>
      </div>

    </div>

    <div class="flex justify-center pt-2">
      <div class="w-20 h-1 bg-gray-600 rounded-full"></div>
    </div>
  </div>

</div>


